export default class DoNotLogError extends Error {
  constructor(message) {
    super(message)
    this.name = 'DoNotLogError'
  }
}
